
import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import { store } from './store';
import axios from './api'
import VueAxios from 'vue-axios'
import VueSimpleAlert from "vue3-simple-alert";
import VueCookies from 'vue3-cookies'
import useVuelidate from '@vuelidate/core'
import vSelect from 'vue-select'
import Swal from 'sweetalert2';
import VueTour from 'vue3-tour';
import 'vue3-tour/dist/vue3-tour.css'
import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */

import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';
import { App as CapacitorApp, URLOpenListenerEvent } from '@capacitor/app';

/* Theme variables */
import './theme/variables.css';
//import * as myjs from '../public/assets/scripts/custom.js'

import { useCookies } from "vue3-cookies";
const { cookies } = useCookies();


CapacitorApp.addListener('backButton', ({ canGoBack }) => {
    if (!canGoBack) {
        VueSimpleAlert.confirm("آیا مایل به خروج از برنامه هستید؟", "", "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
            CapacitorApp.exitApp();
        });
    } else {
        router.go(-1);
    }
});

CapacitorApp.addListener('appUrlOpen', function (event: URLOpenListenerEvent) {
    // Example url: https://beerswift.app/tabs/tabs2
    // slug = /tabs/tabs2
    const slug = event.url.split('.app').pop();

    // We only push to the route if there is a slug present
    if (slug) {
        router.push({
            path: slug,
        });
    }
});

const globalMixin = {
    data: function () {
        return {
            get isMinVersion() {
                /*اشتراکی true  ||||   اصلی false*/
                return true;
            },
            get isFreeVersion() {
                /*برای بازار یا مایکت true  ||||   نسخه اصلی false*/
                return false;
            },
            get appVersionCode() {
                return '4.3.12';
            },

        }
    },
    //computed: {
    //    addButtonTop() {
    //        const x = screen.height;
    //        const topForAddButton = x - 220 + "px";
    //        return topForAddButton;
    //    }
    //},
    methods: {
        //onScroll(e) {
        //    const { scrollTop, offsetHeight, scrollHeight } = e.target;
        //    try {
        //        if (scrollTop > 50) {
        //            document.getElementById("filterTopPage")?.classList.add('filterRowFixed');
        //        } else {
        //            document.getElementById("filterTopPage")?.classList.remove('filterRowFixed');
        //        }
        //    } catch (exceptionVar) {
        //        console.log(exceptionVar);
        //    }
        //},
        goBack() {
            console.log("go back...");
            router.go(-1);
        },
        lableText(fieldName) {
            return store.getters.GetApplicationMenuObjList(fieldName);
        },
        isFieldEnabled(fieldName) {
            return store.getters.GetApplicationMenuObjIsEnabled(fieldName);
        },
        showErrorMessage(msg: any) {
            func.showErrorMessage(msg);
        },
        showSuccessMessage(msg: any) {
            func.showSuccessMessage(msg);
        },
        showMessage(msg: any) {
            func.showMessage(msg);
        },
        showToastErrorMessage(msg: any) {
            func.showToastErrorMessage(msg);
        },
        replacePersianNumbers() {
            func.replacePersianNumbers();
        },
        reloadPage() {

            window.location.reload();
        },


    }

};


const app = createApp(App)
    .use(IonicVue)
    .use(router)
    .use(store)
    .use(VueAxios, axios)
    .use(VueCookies)
    .use(useVuelidate);


app.use(VueTour);
app.mixin(globalMixin);
const v$ = useVuelidate()
app.component("v-select", vSelect);

app.provide('axios', app.config.globalProperties.axios)
router.isReady().then(() => {
    app.mount('#app');
});


const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    showConfirmButton: false,
    timer: 2000
});

export const func = {

    showMessage: (msg: any) => {
        const newLocal = '';
        VueSimpleAlert.alert(msg, newLocal, "info", { confirmButtonText: "تایید" });
    },
    showMessageForUserStatus: (msg: any) => {
        const newLocal = '';
        VueSimpleAlert.alert(msg, newLocal, "info", { confirmButtonText: "تمدید اشتراک" }).then((result) => {
            console.log(result);
            if (result == true) {
                console.log("show sardchal dashboard");

            } else {
                console.log("denied");
            }
        });
    },

    showErrorMessage: (msg: any) => {
        const newLocal = '';
        VueSimpleAlert.alert(msg, newLocal, "error", { confirmButtonText: "تایید" });
    },
    showSuccessMessage: (msg: string) => {
        Toast.fire({
            titleText: msg,
            type: "success",
        })
    },
    showToastErrorMessage: (msg: any) => {
        Toast.fire({
            titleText: msg,
            type: "error",
        })
    },
    replacePersianNumbers: () => {

        const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g],
            arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];

        const inputs = document.querySelectorAll("input,textarea");
        for (let i = 0; i < inputs.length; i++) {
            let str = (<HTMLInputElement>inputs[i]).value;
            if (typeof str === 'string') {
                for (let j = 0; j < 10; j++) {
                    str = str.replace(persianNumbers[j], j.toString()).replace(arabicNumbers[j], j.toString());
                }
            }
            (<HTMLInputElement>inputs[i]).value = str;
            console.log(str);
        }
    },

}